import React from 'react';
import { Link, withRouter} from "react-router-dom";
import '../css/footer.css'


class Footer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            copyright: "",
            logo: "",
            enableAbout: false,
            aboutTitle: "",
            enableFaq: false,
            faqTitle: ""
        }
    }

    componentDidMount () {
                // Back to top button
        window.$(window).scroll(function() {
            if (window.$(this).scrollTop() > 100) {
                window.$('.back-to-top').fadeIn('slow');
            } else {
                window.$('.back-to-top').fadeOut('slow');
            }
        });

        window.$('.back-to-top').click(function(){
            window.$('html, body').animate({scrollTop : 0}, 1500, 'easeInOutExpo');
            return false;
        });

        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.footer !== undefined && this.props.context.footer !== "") {
                let copyright = "";
                let logo = "";
                let enableAbout = false;
                let aboutTitle = "";
                let enableFaq = false;
                let faqTitle = "";

                if (this.props.context.footer.copyright !== undefined && this.props.context.footer.copyright !== "") {
                    copyright = this.props.context.footer.copyright;
                }
                if (this.props.context.footer.logo !== undefined && this.props.context.footer.logo !== "") {
                    logo = this.props.context.footer.logo;
                }

                if (this.props.context.about !== undefined) {
                    if (this.props.context.about.enableLink !== undefined && this.props.context.about.enableLink === "1") {
                        enableAbout = true;
                    }
                    if (this.props.context.about.linkTitle !== undefined) {
                        aboutTitle = this.props.context.about.linkTitle;
                    }
                }

                if (this.props.context.faq !== undefined) {
                    if (this.props.context.faq.enableLink !== undefined && this.props.context.faq.enableLink === "1") {
                        enableFaq = true;
                    }
                    if (this.props.context.faq.linkTitle !== undefined) {
                        faqTitle = this.props.context.faq.linkTitle;
                    }
                }

                this.setState({
                    copyright: copyright,
                    logo: logo,
                    enableAbout: enableAbout,
                    aboutTitle: aboutTitle,
                    enableFaq: enableFaq,
                    faqTitle: faqTitle
                })

            }
        }
    }

    render() {
        let aboutLink; 
        if (this.state.enableAbout) {
            aboutLink = (<span><Link to="/about">{this.state.aboutTitle}</Link></span>);
        }

        let line;
        if (this.state.enableAbout && this.state.enableFaq) {
            line = (<span>｜</span>);
        }

        let faqLink;
        if (this.state.enableFaq) {
            faqLink = (<span><Link to="/faq">{this.state.faqTitle}</Link></span>);
        }

        return (
            <div className="footer-frame">
                <footer id="footer">
                    <div className="container">
                        <div className="footer_logo"><img src={this.state.logo} width="140px" alt="" /></div>
                        <div className="footer_nav">
                            {aboutLink}
                            {line}
                            {faqLink}
                        </div>
                        <div className="copyright">{this.state.copyright}</div>
                    </div>
                </footer>
                <a href="#" className="back-to-top"><i className="fa fa-chevron-up"></i></a>
            </div>
        )
    }
}


export default withRouter(Footer)


// WEBPACK FOOTER //
// ./src/component/footer.js